module.exports = __webpack_public_path__ + "img/ic_next_active_white.9746f10f.svg";